import React, { useState } from 'react';
import { CheckCircle2Icon, Loader2Icon, SendIcon } from 'lucide-react';
import { inquiryTypes } from '../data/site';
type Status = 'idle' | 'submitting' | 'success' | 'error';
const fieldClass = 'w-full border border-stone bg-ivory px-4 py-3.5 text-sm text-ink-950 placeholder:text-slate-400 outline-none transition-colors focus:border-brass-500 focus:bg-white';
const labelClass = 'mb-2 block text-[11px] font-semibold uppercase tracking-[0.18em] text-graphite';
export function ContactForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [form, setForm] = useState({
    name: '',
    organization: '',
    inquiry: inquiryTypes[0],
    message: ''
  });
  const update = (key: keyof typeof form, value: string) => setForm(prev => ({
    ...prev,
    [key]: value
  }));
  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!form.name.trim() || !form.organization.trim() || !form.message.trim()) {
      setStatus('error');
      return;
    }
    setStatus('submitting');
    window.setTimeout(() => setStatus('success'), 900);
  };
  if (status === 'success') {
    return <div role="status" className="border border-brass-500 bg-ivory p-8" data-id="element-20" data-mp="3ui6tqc2sizvr">
        <CheckCircle2Icon size={28} className="text-brass-500" data-id="element-21" data-mp="363yd7pqgttn" />
        <h3 className="mt-5 font-display text-xl text-ink-950" data-id="element-22" data-mp="84yge7fvmecp">
          Inquiry received
        </h3>
        <p className="mt-3 max-w-sm text-sm leading-relaxed text-graphite" data-id="element-23" data-mp="36n43q0s92qdp">
          Thank you, {form.name.split(' ')[0]}. Your{' '}
          {form.inquiry.toLowerCase()} inquiry has been logged. Expect a
          response within two business days.
        </p>
        <button type="button" onClick={() => {
        setForm({
          name: '',
          organization: '',
          inquiry: inquiryTypes[0],
          message: ''
        });
        setStatus('idle');
      }} className="mt-7 border border-ink-950 px-5 py-3 font-display text-[12px] text-ink-950 transition-colors hover:bg-ink-950 hover:text-ivory" data-id="element-24" data-mp="3km3pn0odor66">
          Submit another inquiry
        </button>
      </div>;
  }
  return <form onSubmit={onSubmit} noValidate className="space-y-5" data-id="element-25" data-mp="35wx7d6r9co0i">
      <div className="grid gap-5 sm:grid-cols-2" data-id="element-26" data-mp="35wdwub3xt1wi">
        <div data-id="element-27" data-mp="30xucgf4zry69">
          <label htmlFor="name" className={labelClass} data-id="element-28" data-mp="30z5gmg2cn7xw">
            Name
          </label>
          <input id="name" name="name" type="text" autoComplete="name" value={form.name} onChange={e => update('name', e.target.value)} placeholder="Jane Whitfield" className={fieldClass} data-id="element-29" data-mp="2d7q6400f5kbk" />
        </div>
        <div data-id="element-30" data-mp="2i6t3cya5qm8z">
          <label htmlFor="organization" className={labelClass} data-id="element-31" data-mp="2i61leq9hgn16">
            Organization
          </label>
          <input id="organization" name="organization" type="text" autoComplete="organization" value={form.organization} onChange={e => update('organization', e.target.value)} placeholder="Meridian Health Ventures" className={fieldClass} data-id="element-32" data-mp="1ug78y9t2t0hg" />
        </div>
      </div>

      <div data-id="element-33" data-mp="3s6njqns1rkok">
        <label htmlFor="inquiry" className={labelClass} data-id="element-34" data-mp="3s75l1ytkgp3c">
          Inquiry Type
        </label>
        <select id="inquiry" name="inquiry" value={form.inquiry} onChange={e => update('inquiry', e.target.value)} className={`${fieldClass} appearance-none`} data-id="element-35" data-mp="102rx1u648qh">
          {inquiryTypes.map(type => <option key={type} value={type} data-id="element-36" data-mp="er7o1tybuiw2">
              {type}
            </option>)}
        </select>
      </div>

      <div data-id="element-37" data-mp="johjprcb7qsc">
        <label htmlFor="message" className={labelClass} data-id="element-38" data-mp="jo7tq3r9ljmn">
          Message
        </label>
        <textarea id="message" name="message" rows={5} value={form.message} onChange={e => update('message', e.target.value)} placeholder="Share the mandate, timeline, and what success looks like." className={`${fieldClass} resize-none`} data-id="element-39" data-mp="2zg5crbo7cz5v" />
      </div>

      {status === 'error' && <p role="alert" className="text-[13px] text-red-700" data-id="element-40" data-mp="3awtmla24di1p">
          Please complete your name, organization, and message before
          submitting.
        </p>}

      <button type="submit" disabled={status === 'submitting'} className="inline-flex w-full items-center justify-center gap-2 bg-ink-950 px-7 py-4 font-display text-[13px] text-ivory transition-colors hover:bg-ink-800 disabled:cursor-not-allowed disabled:opacity-70 sm:w-auto" data-id="element-41" data-mp="35wfdrpsp242m">
        {status === 'submitting' ? <>
            <Loader2Icon size={16} className="animate-spin" data-id="element-42" data-mp="3oo839a8k175l" />
            Sending inquiry
          </> : <>
            <SendIcon size={16} data-id="element-43" data-mp="2i6bajjjf46c5" />
            Submit inquiry
          </>}
      </button>
    </form>;
}